import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

export async function activeSegmentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API + "segment/active-segment",
    {},
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function deactiveSegmentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API + "segment/deactive-segment",
    {},
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function getActiveSegmentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API + "segment/load-active-segment",
    {},
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function createSegmentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "segment/create-segment", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getListSegmentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "segment/get-segment-list", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function updateSegmentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "segment/edit-segment", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function deleteSegmentAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "segment/delete-segment", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function regenerateSegmentMemberAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "segment/regenerate-segment-member", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getDataMemberAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    BASE_URL_API + "consolidated-view/load-specific-component",
    data,
    {
      headers: {
        Authorization: token,
      },
    }
  );
}

export async function updateMemberAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "object/update-record", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function deleteMemberAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "object/delete-record", data, {
    headers: {
      Authorization: token,
    },
  });
}
